import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getUser, logout } from '../../utils/auth';

export default function Navbar() {
  const navigate = useNavigate();
  const user = getUser();
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  const handleLogout = async () => {
    if (isLoggingOut) return;
    
    setIsLoggingOut(true);
    try {
      await logout();
      navigate('/login');
    } catch (error) {
      console.error('Logout failed:', error);
      navigate('/login');
    } finally {
      setIsLoggingOut(false);
    }
  };

  const getRoleDisplay = (role: string) => {
    return role.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
  };

  return (
    <nav className="bg-white border-b border-gray-200 sticky top-0 z-50">
      <div className="px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-teal-500 rounded-lg flex items-center justify-center">
              <i className="ri-hospital-line text-xl text-white"></i>
            </div>
            <div>
              <h1 className="text-lg font-bold text-gray-800">MedCamp Plus</h1>
              <p className="text-xs text-gray-500">{user ? getRoleDisplay(user.role) : ''}</p>
            </div>
          </div>

          <div className="flex items-center gap-4">
            {/* Powered By */}
            <a
              href="https://www.harishwargroup.in/"
              target="_blank"
              rel="noopener noreferrer"
              className="hidden md:flex items-center gap-1.5 px-3 py-1.5 bg-gray-50 rounded-lg border border-gray-100 hover:bg-gray-100 transition-colors cursor-pointer"
            >
              <span className="text-[10px] text-gray-400">Powered by</span>
              <div className="w-8 h-8 flex items-center justify-center overflow-hidden rounded">
                <img
                  src="https://static.readdy.ai/image/78f0141fe7d482cc0befb0c980b12d44/8e5eacadefcfbc1e0352bded8ee34e5b.jpeg"
                  alt="Harishwar Solutions"
                  className="w-full h-full object-cover"
                />
              </div>
              <span className="text-[10px] font-semibold text-gray-600 whitespace-nowrap">Harishwar Solutions</span>
            </a>

            <div className="hidden sm:block text-right">
              <p className="text-sm font-medium text-gray-800">{user?.displayName || user?.username}</p>
              <p className="text-xs text-gray-500">{user ? getRoleDisplay(user.role) : ''}</p>
            </div>
            <button
              onClick={handleLogout}
              disabled={isLoggingOut}
              className="flex items-center gap-2 px-4 py-2 text-sm font-medium text-red-600 hover:bg-red-50 rounded-lg transition-colors whitespace-nowrap cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {isLoggingOut ? (
                <i className="ri-loader-4-line animate-spin"></i>
              ) : (
                <i className="ri-logout-box-line"></i>
              )}
              <span className="hidden sm:inline">{isLoggingOut ? 'Logging out...' : 'Logout'}</span>
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
}